module.exports = __webpack_public_path__ + "img/23.7635c60f.jpg";